<template>
  <div>
    <common-dialog
      ref="dialog"
      width="100%"
      unit="特殊工艺工单"
      edit-title
      id-key="UserId"
      @close-saved="$emit('close-saved')"
      @closed="$emit('onClosed')"
    >
    <div style="margin-bottom: 18px;">产品明细</div>
      <el-table
        ref="list2"
        :data="Products"
        class="table_bottom table-line tb-c-head"
        border
      >
        <el-table-column
          prop="ProductNo"
          label="加工后编码"
          min-width="120"
        ></el-table-column>
        <el-table-column prop="ProductName" label="加工后名称" min-width="120">
          <template slot-scope="{ row, $index }">
            <account-select
              v-model="row.ProductName"
              v-if="Status === 0"
              :source="DAccount"
              @select="onSelect($event, row, $index)"
              :pageSize="pageParams.pageSize"
              :pageIndex="pageParams.pageIndex"
              :listTotal="listTotal"
              @inputText="inputText($event, row)"
              @click.native="resetFun"
              @currentPage="currentPage"
              keyword="ProductName"
              :pageType="true"
            />
            <span v-else>{{ row.ProductName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ProductSpec"
          label="规格"
          min-width="120"
        ></el-table-column>
        <el-table-column prop="PropertyName" label="属性" min-width="120">
          <template slot-scope="{ row }">
            <el-select
              v-if="Status === 0"
              v-model="row.PropertyId"
              v-show="row.UseProcess"
              @change="changeProperty($event, row)"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.PropertyId"
                :value="item.PropertyId"
                :label="item.PropertyName"
              ></el-option>
            </el-select>
            <span v-else>{{ row.PropertyName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ColorId" label="颜色" min-width="120">
          <template slot-scope="{ row }">
            <el-select
              v-model="row.ColorId"
              @change="changeColor($event, row)"
              v-show="row.UseColor"
              v-if="Status === 0"
            >
              <el-option
                v-for="item in row.Colors"
                :key="item.ColorId"
                :value="item.ColorId"
                :label="item.ColorName"
              ></el-option>
            </el-select>
            <span v-else>{{ row.ColorName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="PdUnitName"
          label="单位"
          min-width="120"
        ></el-table-column>
        <el-table-column prop="Quantity" label="需求数量" min-width="120">
          <template slot-scope="{ row }">
            <el-input
              clearable
              v-model="row.Quantity"
              @change="changeQua($event, row)"
              placeholder="请输入数量"
              type="number"
            />
          </template>
        </el-table-column>
        <el-table-column prop="ImgUrl" label="图片" min-width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewImg(row)"
              >{{ row.ProductId ? "查看" : "" }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="ProcessStage" label="加工阶段" min-width="120">
          <template slot-scope="{ row }">
            <span>{{
              (() => {
                if (row.ProcessStage === 4) {
                  return "组合";
                } else if (row.ProcessStage === 3) {
                  return "装配";
                } else if (row.ProcessStage === 1) {
                  return "注塑";
                } else if (row.ProcessStage === 2) {
                  return "配件";
                } else if (row.ProcessStage === 0) {
                  return "无";
                }
              })()
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ProduceTypeName"
          label="存货类型"
          min-width="120"
        ></el-table-column>

        <el-table-column prop="Quantity" label="生产数量" min-width="120">
          <template slot-scope="{ row }">
            <!-- <span>{{
              row.Quantity - (row.StockQuantity ?? 0) < 0
                ? 0
                : row.Quantity - (row.StockQuantity ?? 0)
            }}</span> -->
            <span>{{ row.Quantity }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="PickingWarehouseId"
          label="预入仓"
          min-width="120"
        >
          <template slot-scope="{ row }">
            <el-select v-model="row.PickingWarehouseId">
              <el-option label="无" :value="0"></el-option>
              <el-option
                v-for="item in warehouseList"
                :key="item.WarehouseId"
                :label="item.WarehouseName"
                :value="item.WarehouseId"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="SchedulingType"
          label="排产类型"
          min-width="120"
          key="column1"
          v-if="!QuickProcess"
        >
          <template slot-scope="{ row }">
            <el-select
              v-show="!QuickProcess"
              v-if="Status === 0"
              v-model="row.SchedulingType"
              @change="changeSchedulingType($event, row)"
            >
              <el-option
                key="SchedulingType1"
                label="部门"
                :value="0"
              ></el-option>
              <el-option
                key="SchedulingType2"
                label="设备"
                :value="1"
              ></el-option>
            </el-select>
            <span v-show="!QuickProcess" v-else>{{
              row.SchedulingType === 0 ? "部门" : "设备"
            }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column
          label="加工部门/设备"
          min-width="120"
          key="column2"
          v-if="!QuickProcess"
        >
          <template slot-scope="{ row }">
            <dp-select
              v-if="row.SchedulingType === 0"
              style="width: 180px"
              :disabled="Status === 1"
              v-model="row.DpId"
              v-show="!QuickProcess"
            />
            <el-select
              v-else
              style="width: 180px"
              :disabled="Status === 1"
              v-model="row.MaintenanceId"
              v-show="!QuickProcess"
              ><el-option
                v-for="item in equipmentList"
                :key="item.EquipmentId"
                :label="item.EquipmentName"
                :value="item.EquipmentId"
              ></el-option>
            </el-select>
          </template>
        </el-table-column> -->
        <el-table-column
          label="生产部门"
          min-width="120"
          key="column2"
        >
          <template slot-scope="{ row }">
            <dp-select
              v-show="row.ProductionType == 0"
              style="width: 180px"
              :disabled="Status === 1"
              v-model="row.DpId"
            />
          </template>
        </el-table-column>
        <el-table-column prop="ProductionType" label="生产类型" min-width="120">
          <template slot-scope="{ row }">
            <el-select
              v-model="row.ProductionType"
              @change="changeProductionType($event, row)"
              v-if="Status === 0"
            >
              <el-option
                key="ProductionType1"
                label="自产"
                :value="0"
                v-if="
                  row.IsChangeProductionType &&
                  row.IsChangeProductionType.includes(0)
                "
              ></el-option>
              <el-option
                key="ProductionType2"
                label="委外"
                :value="1"
                v-if="
                  row.IsChangeProductionType &&
                  row.IsChangeProductionType.includes(1)
                "
              ></el-option>
              <!-- <el-option key="ProductionType3" label="自产&委外" :value="2"></el-option> -->
            </el-select>
            <span v-else>{{
              row.ProductionType === 0
                ? "自产"
                : row.ProductionType === 1
                ? "委外"
                : ""
            }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="ProductionDpId" label="加工商" min-width="120">
          <template slot-scope="{ row }">
            <!-- <el-select v-model="row.ProductionDpId"  @change="editT(row)" :disabled="Status === 1 || row.ProductionType !== 1"> -->
            <el-select
              v-model="row.ProductionDpId"
              v-show="Status != 1 && row.ProductionType == 1"
            >
              <el-option
                v-for="item in tradeUnitList"
                :key="item.TradeUnitId"
                :label="item.FullName"
                :value="item.TradeUnitId"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="StartTime" label="开始日期" min-width="120">
          <template slot-scope="{ row }">
            <el-date-picker
              v-if="Status === 0"
              v-model="row.StartTime"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
            <span v-else>{{ row.StartTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="DocDate" label="单据日期" min-width="120">
          <template slot-scope="{ row }">
            <el-date-picker
              v-if="Status === 0"
              v-model="row.DocDate"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              @change="dateChange($event, row, 'DocDate')"
            >
            </el-date-picker>
            <span v-else>{{ row.DocDate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="EndTime" label="预计完工日期" min-width="160">
          <template slot-scope="{ row }">
            <el-date-picker
              v-if="Status === 0"
              v-model="row.EndTime"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              @change="dateChange($event, row, 'EndTime')"
            >
            </el-date-picker>
            <span v-else>{{ row.EndTime }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="Remark" label="工单备注" min-width="120">
          <template slot-scope="{ row }">
            <el-input
              v-model="row.Remark"
              type="text"
              v-if="Status === 0"
            ></el-input>
            <span v-else>{{ row.Remark }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
        prop="Bomno"
        label="BOM版本号"
        min-width="120"
      >
         <template slot-scope="{ row }">
          <el-select v-model="row.Bomno"  v-if="Status === 0">
          </el-select>
          <span v-else>{{row.Bomno}}</span>
        </template>
      </el-table-column> -->
      </el-table>

      <el-table
        :data="DetailModels"
        class="table_bottom table-line tb-c-head"
        border
      >
        <el-table-column
          prop="ProductNo"
          label="子件编码"
          min-width="120"
        ></el-table-column>
        <el-table-column prop="ProductName" label="子件名称" min-width="120">
        </el-table-column>
        <el-table-column
          prop="ProductSpec"
          label="规格"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="PdUnitName"
          label="单位"
          min-width="120"
        ></el-table-column>
        <el-table-column prop="PropertyName" label="加工前属性" min-width="120">
          <template slot-scope="{ row }">
            <el-select
              v-if="Status === 0"
              v-model="row.PropertyId"
              v-show="row.UseProcess"
              @change="changeProperty($event, row)"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.PropertyId"
                :value="item.PropertyId"
                :label="item.PropertyName"
              ></el-option>
            </el-select>
            <span v-else>{{ row.PropertyName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ColorId" label="加工前颜色" min-width="120">
          <template slot-scope="{ row }">
            <el-select
              v-model="row.ColorId"
              @change="changeColor($event, row)"
              v-show="row.UseColor"
              v-if="Status === 0"
            >
              <el-option
                v-for="item in row.Colors"
                :key="item.ColorId"
                :value="item.ColorId"
                :label="item.ColorName"
              ></el-option>
            </el-select>
            <span v-else>{{ row.ColorName }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="Quantity" label="需求数量" min-width="120">
          <template slot-scope="{ row }">
            <el-input
              v-if="Status === 0"
              clearable
              v-model="row.Quantity"
              placeholder="请输入数量"
              @change="changeQua($event, row)"
              type="number"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="OutWarehouseId"
          label="预出仓"
          min-width="120"
        > 
          <template slot-scope="{ row ,$index}">
            <el-select v-model="row.OutWarehouseId" @change="changeOutWarehouse($event, row,$index)">
              <el-option
                v-for="item in warehouseList"
                :key="item.WarehouseId"
                :label="item.WarehouseName"
                :value="item.WarehouseId"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ImgUrl" label="图片" min-width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewImg(row)"
              >{{ row.ProductId ? "查看" : "" }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="Remarks" label="备注" min-width="120">
          <template slot-scope="{ row }">
            <el-input
              clearable
              v-model="row.Remarks"
              placeholder="请输入备注"
              type="text"
            />
          </template>
        </el-table-column>
      </el-table>

      <template slot="footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
    <img-dialog ref="imgDialog" :imgs="imgs" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import accountSelect from "@/components/production/clothmanagement/cloth/select";
import dpSelect from "@/components/production/clothmanagement/cloth/workorder/dpSelect";
import { urlHttp } from "@/components/production/clothmanagement/cloth/workorder/bomConfig";
import imgDialog from "@/components/production/clothmanagement/cloth/workorder/imgDialog";
import vSelect from "@/components/production/clothmanagement/cloth/workorder/vSelect";

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    accountSelect,
    dpSelect,
    imgDialog,
    vSelect,
  },
  data() {
    return {
      activeName: "tab1",
      api: require("@/api/production/workDoc").default,
      pdApi: require("@/api/ba/product").default, // product是产品 到时换成模具API
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      Head: [
        { Value: "ProductNo", Name: "产品编码", Width: "180" },
        { Value: "ProductName", Name: "产品名称", Width: "180" },
      ],
      pinitDAccount: [],
      pinitTotal: 0,
      pDAccount: [],
      plistTotal: 0,
      ppageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      Status: 0,
      imgs: [],
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      tradeUnitList: [],
      propertyApi: require("@/api/ba/property").default,
      propertyList: [],
      equipmentApi: require("@/api/ba/equipment").default,
      equipmentList: [],
      optionApi: require("@/api/sy/option").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      warehouseList: [],
      QuickProcess: false, // 是否启动快捷方式
      IsSelfPicking:true,// 是否启用自制工单领料
      IsOutPicking: true,
      Products: [
        {
          T: 0,
          WorkDocId: 0,
          WorkDocNo: "",
          WorkDocProductId: 0,
          ProductId: 0,
          ProductNo: "",
          ProductName: "",
          ProductSpec: "",
          PdUnitId: 0,
          PdUnitName: "",
          ColorId: null,
          Quantity: "",
          ImgUrl: "",
          ProcessStage: 0,
          ProduceTypeName: "",
          SchedulingType: null,
          DpId: null,
          MaintenanceId: null,
          ProductionType: "",
          ProductionDpId: null,
          DocDate: this.$commonJs.getToday(),
          StartTime: this.$commonJs.getToday(),
          EndTime: this.$commonJs.getToday(),
          Remark: "",
          ProgrammeId: 0,
          OrderProductNo: "",
          PropertyId: null,
          PropertyName: "",
          PickingWarehouseId: null,
        },
      ],
      ProcessModels: [
        {
          ProductName: "",
          ProductNo: "",
          ProgrammeName: "",
          ProgrammeId: 0,
          Processes: [],
        },
      ],
      DetailModels: [
        {
          T: 0,
          WorkDocId: 0,
          WorkDocNo: "",
          WorkDocMaterialId: 0,
          ProductId: 0,
          ProductNo: "",
          ProductName: "",
          ProductSpec: "",
          PdUnitId: 0,
          PdUnitName: "",
          PropertyId: null,
          PropertyName: "",
          Quantity: "",
          ImgUrl: "",
          ProcessStage: 0,
          ProduceTypeName: "",
          ColorId: null,
          ColorName: "",
          Colors: [],
          UseProcess: true,
          UseColor: true,
          MouldNo: "",
          MouldId: 0,
          MouldName: "",
          Rate: 0,
          Loss: 0,
          Ration: 0,
          RationUnit: 0,
          Remarks: "",
          OutWarehouseId:null,
          WarehouseName:""
        },
      ],
      programmeCurrentRow: null,
    };
  },
  created() {
    this.pdApi
      .list({ Status: 1, ProcessStages: [1], pageIndex: 1, pageSize: 7 })
      .then((res) => {
        let data2 = res.Data.filter((item) => {
          return item.UseProcess && item.ProduceTypeName == "胶件";
        });

        console.log("data2", data2);

        this.DAccount = data2;
        this.initDAccount = data2;
        this.listTotal = data2.length;
        this.initTotal = data2.length;
      });

    this.warehouseApi.list({ WarehouseType: 1 }).then((res) => {
      if (res.Code === 0) {
        this.warehouseList = res.Data;
      }
    });

    this.equipmentApi.list({ Statuses: [1, 2] }).then((res) => {
      if (res.Code === 0) {
        this.equipmentList = res.Data;
      }
    });
    this.tradeUnitApi.list({ TradeUnitType: 3, Status: 1 }).then((res) => {
      if (res.Code === 0) {
        this.tradeUnitList = res.Data;
      }
    });

    this.propertyApi.list({ Status: 1 }).then((res) => {
      if (res.Code === 0) {
        this.propertyList = res.Data;
      }
    });

    this.optionApi.getProductSetting().then((res) => {
      if (res.Code === 0) {
        this.QuickProcess = res.Data.QuickProcess;
      }
    });
    this.optionApi.getInitialSetting().then((res) => {
      if (res.Code === 0) {
        this.IsSelfPicking = res.Data.IsSelfPicking;
        this.IsOutPicking = res.Data.IsOutPicking;
      }
    });
  },
  methods: {
    changeOutWarehouse(val,row,index){
      // console.log("val",val,"row",row)   
      if (row.T !== 0) {
        row.T = 1;
      }
      var obj = { ...row };
      this.DetailModels.splice(index,1,obj);
      //this.$forceUpdate()
    },
    close() {
      this.$refs.dialog.close();
    },
    dateChange(data, row, type) {
      const date = this.$dayjs(data).valueOf();
      const startDate = this.$dayjs(row.StartTime).valueOf();
      if (date < startDate) {
        this.$message.warning(
          `${
            type == "DocDate" ? "单据日期" : "预计完工日期"
          }需要大于等于开始日期, 请重新选择！`
        );
        row[type] = row.StartTime;
        return;
      }
    },
    changeSchedulingType(val, row) {
      if (val === 0) {
        row.DpId = 0;
      } else if (val === 1) {
        row.MaintenanceId = 0;
      }
    },
    base64ToFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg);
      const ImgUrl = res.Data;
      if (!ImgUrl || ImgUrl?.length < 1)
        return this.$message.warning("无图片！");
      let imgs = [];
      ImgUrl.forEach((item) => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl));
        // imgs.push(imgBlob);
        imgs.push('/api' + item.ImgUrl)
      });
      this.imgs = imgs;
      this.$refs.imgDialog.open();
    },
    // viewImg(ImgUrl) {
    //   let imgs = ImgUrl.split(",");
    //   imgs.forEach((item) => {
    //     item = urlHttp + item;
    //   });

    //   this.imgs = imgs;
    //   this.$refs.imgDialog.open();
    // },
    changeColor(val, row) {
      let item = row.Colors.filter((item) => {
        return item.ColorId === val;
      })[0];

      row.ColorName = item.ColorName;
    },
    //生产类型选择
    changeProductionType(e, row) {
      console.log("e", e);
      if (e === 0) {
        row.ProductionDpId = 0;
      }
    },
    changeProperty(val, row) {
      let item = this.propertyList.filter((item) => {
        return item.PropertyId === val;
      })[0];

      row.PropertyName = item.PropertyName;
    },
    changeQua(val, row) {
      row.Quantity = parseFloat(val);
    },
    onSelect(e, row) {
      row.ColorId = null;
      row.Property = "";
      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductSpec = e.ProductSpec;
      row.ProcessStage = e.ProcessStage;
      row.ProduceTypeName = e.ProduceTypeName;
      row.ProductId = e.ProductId;
      row.Colors = e.Colors;
      row.PdUnitName = e.PdUnitName;
      row.PdUnitId = e.PdUnitId;
      row.UseProcess = e.UseProcess;
      row.UseColor = e.UseColor;
      row.Mould = e.Mould;
      row.MouldId = e.MouldId;
      row.MouldName = e.MouldName;
      row.ProductionDpId = e.DefaultSupplier;
      row.ProductionType = e.ProductNature == 1 ? 1 : 0;
      if (e.ProductNature == 2) {
        row.IsChangeProductionType = [0, 1];
      } else if (e.ProductNature == 0) {
        row.IsChangeProductionType = [0];
      } else if (e.ProductNature == 1) {
        row.IsChangeProductionType = [1];
      }
      // row.IsChangeProductionType=e.ProductNature==2?false:true

      this.DetailModels[0].ProductName = e.ProductName;
      this.DetailModels[0].ProductNo = e.ProductNo;
      this.DetailModels[0].ProductSpec = e.ProductSpec;
      this.DetailModels[0].ProcessStage = e.ProcessStage;
      this.DetailModels[0].ProduceTypeName = e.ProduceTypeName;
      this.DetailModels[0].ProductId = e.ProductId;
      this.DetailModels[0].Colors = e.Colors;
      this.DetailModels[0].PdUnitName = e.PdUnitName;
      this.DetailModels[0].PdUnitId = e.PdUnitId;
      this.DetailModels[0].UseProcess = e.UseProcess;
      this.DetailModels[0].UseColor = e.UseColor;
      this.DetailModels[0].Mould = e.Mould;
      this.DetailModels[0].MouldId = e.MouldId;
      this.DetailModels[0].MouldName = e.MouldName;
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    presetFun() {
      this.ppageParams.pageIndex = 1;
      this.pDAccount = this.pinitDAccount;
      this.plistTotal = this.pinitTotal;
    },
    currentPage({val, text1}) {
      this.pageParams.pageIndex = val;
      this.pdApi
        .list({ProcessStages: [1], pageIndex: val, pageSize: 7, Status: 1 , ProductName: text1,})
        .then((res) => {
          if (res.Code == 0) {
            let data2 = res.Data.filter((item) => {
              return item.UseProcess && item.ProduceTypeName == "胶件";
            });
            this.DAccount = data2;
            this.listTotal = res.Count;
          }
        });
    },
    pcurrentPage({val, text1}) {
      this.ppageParams.pageIndex = val;
      this.pdApi
        .list({ pageIndex: val, pageSize: 7, Status: 1 , ProductName: text1,})
        .then((res) => {
          if (res.Code == 0) {
            let data2 = res.Data.filter((item) => {
              return item.UseProcess && item.ProduceTypeName == "胶件";
            });
            this.pDAccount = data2;
            this.plistTotal = res.Count;
          }
        });
    },
    inputText(text, row) {
      // console.log('text',text, row)
      // if (text == row.ProductName) {
      //   //console.log("相同", text);
      //   return;
      // }
      // row.ProductName = text;
      //  this.pdApi.list({pageIndex:1,pageSize:7 ,ProductName:text}).then((res) => {
      //       if (res.Code == 0) {

      //         this.DAccount = res.Data;

      //         this.listTotal=res.Count
      //       }
      //     });

      this.pdApi
        .list({
          Status: 1,
          ProcessStages: [1],
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
        })
        .then((res) => {
          let data2 = res.Data.filter((item) => {
            return item.UseProcess && item.ProduceTypeName == "胶件";
          });

          this.DAccount = data2;
          this.listTotal = data2.length;
        });
    },
    pinputText(text, row) {
      this.pdApi
        .list({ pageIndex: 1, pageSize: 7, ProductName: text, Status: 1 })
        .then((res) => {
          if (res.Code == 0) {
            let data2 = res.Data.filter((item) => {
              return item.UseProcess && item.ProduceTypeName == "胶件";
            });
            this.pDAccount = data2;

            this.plistTotal = res.Count;
          }
        });
    },
    add() {
      this.DetailModels.push({
        T: 0,
        WorkDocId: 0,
        WorkDocNo: "",
        WorkDocMaterialId: 0,
        ProductId: 0,
        ProductNo: "",
        ProductName: "",
        ProductSpec: "",
        PdUnitId: 0,
        PdUnitName: "",
        Property: "",
        PropertyName: "",
        Quantity: "",
        ImgUrl: "",
        ProcessStage: 0,
        ProduceTypeName: "",
        ColorId: null,
        ColorName: "",
        Colors: [],
        UseProcess: true,
        UseColor: true,
        MouldNo: "",
        MouldId: 0,
        MouldName: "",
        Rate: 0,
        Loss: 0,
        Ration: 0,
        RationUnit: 0,
        Remarks: "",
        OutWarehouseId:null
      });
    },
    del(row, index) {
      this.DetailModels.splice(index, 1);
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }

      return {
        start,
        end,
      };
    },
    save() {
      if (!this.Products[0].Quantity)
        return this.$message({ type: "warning", message: "需求数量不能为0" });

      // if (this.Products[0].PickingWarehouseId == null) {
      //   this.$message({ type: "warning", message: "领料仓库不能为空" });
      //   return;
      // }

      if (this.Products[0].ProductionType == 0 && !this.Products[0].DpId)
        return this.$message({ type: "warning", message: "请选择生产部门" });
      else if (this.Products[0].ProductionType == 1 && !this.Products[0].ProductionDpId)
        return this.$message({ type: "warning", message: "请选择加工商" });
      if (this.propertyList.length && this.Status == 0 && !this.Products[0].PropertyId) {
        return this.$message({ type: "warning", message: "请选择属性" });
      }
      if (this.Products[0].Colors.length && !this.Products[0].ColorId) {
        return this.$message({ type: "warning", message: "请选择颜色" });
      }
      if (!this.QuickProcess) {
        if (this.Products[0].SchedulingType == null)
          return this.$message({
            type: "warning",
            message: "产品明细的排产类型需必选",
          });
        if (this.Products[0].ProductionType !== 1 &&
          this.Products[0].SchedulingType == 0 &&
          (this.Products[0].DpId == null || this.Products[0].DpId == 0)
        ) {
          return this.$message({ type: "warning", message: "部门不能为空" });
        }
        if (this.Products[0].ProductionType !== 1 &&
          this.Products[0].SchedulingType == 1 &&
          (this.Products[0].MaintenanceId == null ||
            this.Products[0].MaintenanceId == 0)
        ) {
          return this.$message({ type: "warning", message: "设备不能为空" });
        }
      }
      if(!this.IsSelfPicking){
      console.log("this.Products[0].ProductionType",this.Products[0].ProductionType)
        if( this.Products[0].ProductionType === 0 ){
         var len=this.DetailModels;
         for(var i=0;i<len;i++){
          var detailModel=this.DetailModels[i];
          if(!detailModel.OutWarehouseId){
            return this.$message({ type: "warning", message: "启用自制工单不领料，预出仓不能为空" });
          }
         }
        }
      }
      if(!this.IsOutPicking) {
        if( this.CombinationBom[0].ProductionType == 1 ){
         var len=this.DetailModels;
         for(var i=0;i<len;i++){
          var detailModel=this.DetailModels[i];
          if(!detailModel.OutWarehouseId) {
            return this.$message({ type: "warning", message: "启用委外工单不领料，预出仓不能为空" });
          }
         }
        }
      }
      if (
        this.Products[0].ProductionType !== 0 &&
        this.Products[0].ProductionDpId == null
      ) {
        return this.$message({ type: "warning", message: "供应商不能为空" });
      }

      let arr = [];
      let length = this.Products.length;

      for (let i = 0; i < length; ++i) {
        let ProductModels = [];
        let ProcessModels = [];
        let MaterialModels = [];
        let o1 = {
          T: this.Products[i].T,
          WorkDocProductId: this.Products[i].WorkDocProductId || 0,
          WorkDocId: this.Products[i].WorkDocId,
          PdUnitId: this.Products[i].PdUnitId,
          ProductId: this.Products[i].ProductId,
          TebomId: this.Products[i].TebomId,
          TespecialBomId: this.Products[i].TespecialBomId,
          ProgrammeId: this.Products[i].ProgrammeId,
          ColorId: this.Products[i].ColorId||0,
          PropertyId: this.Products[i].PropertyId||0,
          Quantity: this.Products[i].Quantity,
          SourceDtsId: 0,
          RpType: this.Products[i].ProcessStage,
          RpRequirement: "",
          SnType: 0,
          Loss: 0,
          Status: 0,
          WorkDocNo: this.Products[i].WorkDocNo || "",
        };

        this.DetailModels.forEach((item) => {
          let o = {
            T: item.T,
            WorkDocMaterialId: item.WorkDocMaterialId,
            WorkDocId: this.Products[i].WorkDocId,
            ProductId: item.ProductId,
            ColorId: item.ColorId||0,
            Colors: item.Colors||[],
            Ration: item.Ration,
            RationUnit: item.RationUnit,
            Quantity: item.Quantity,
            QuantityUnit: item.PdUnitId,
            PropertyId: item.PropertyId ?? 0,
            Rate: item.Rate,
            Loss: item.Loss,
            NeedQuantity: item.NeedQuantity,
            OutWarehouseId:item.OutWarehouseId
            // ChildTeProductId: item.ChildTeProductId ?? 0,
          };
          MaterialModels.push(o);
        });

        let {
          WorkDocId,
          WorkDocNo = "",
          SchedulingType,
          DpId,
          MaintenanceId,
          ProductionType,
          ProductionDpId,
          DocDate,
          StartTime,
          EndTime,
          Remark = "",
          PickingWarehouseId,
        } = this.Products[i];
        if (DpId == null) {
          DpId = 0;
        }
        if (MaintenanceId == null) {
          MaintenanceId = 0;
        }
        // let {start} = this.cycleChange('今天')
        SchedulingType = SchedulingType ?? 0;
        ProductionDpId = ProductionDpId ?? 0;
        let data = {
          Stage: 1,
          WorkDocType: 0,
          ProductType: 0,
          // StartTime: start,
          WorkDocId,
          WorkDocNo,
          EndTime,
          StartTime,
          SchedulingType,
          DpId,
          MaintenanceId,
          ProductionType,
          ProductionDpId,
          DocDate,
          Remark,
          PickingWarehouseId,
        };
        ProductModels.push(o1);

        if (
          MaterialModels.some(
            (item) =>
              JSON.stringify(item.Quantity) == "null" || item.Quantity === ""
          )
        ) {
          this.$message({ type: "warning", message: "子件需求数量未填写" });
          return;
        }
        let p = MaterialModels.find(x => this.propertyList.length && !x.PropertyId);
        if(p) {
          this.$message({ type: "warning", message: "请选择加工前属性" });
          return;
        }
        let p2 = MaterialModels.find(x => x.Colors.length && !x.ColorId);
        if(p2) {
          this.$message({ type: "warning", message: "请选择加工前颜色" });
          return;
        }
        let obj = {
          ProductModels,
          ProcessModels: [],
          MaterialModels,
          ...data,
          PickingWarehouseId: data.PickingWarehouseId||0,
        };

        arr.push(obj);
      }

      let WorkDocModels = [];
      WorkDocModels.push(...arr);

      let saveData = {
        WorkDocModels,
      };
      if (!saveData.WorkDocModels[0].StartTime) {
        this.$message.warning("请填写开始日期！");
        return;
      }
      if (!saveData.WorkDocModels[0].DocDate) {
        this.$message.warning("请填写单据日期！");
        return;
      }
      if (!saveData.WorkDocModels[0].EndTime) {
        this.$message.warning("请填写预计完工日期！");
        return;
      }
      if (
        this.$dayjs(saveData.WorkDocModels[0].StartTime).valueOf() >
        this.$dayjs(saveData.WorkDocModels[0].DocDate).valueOf()
      ) {
        this.$message.warning("开始日期需要小于单据日期，请重新选择！");
        return;
      }
      if (
        this.$dayjs(saveData.WorkDocModels[0].StartTime).valueOf() >
        this.$dayjs(saveData.WorkDocModels[0].EndTime).valueOf()
      ) {
        this.$message.warning("开始日期需要小于预计完工日期，请重新选择！");
        return;
      }
      console.log("saveData", saveData);
      var loading = this.$loading({
        lock: true,
        text: "正在查询...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api
        .save(saveData)
        .then((res) => {
          loading.close();
          if (res.Code === 0) {
            console.log("res.Data", res.Data);
            this.$emit("saved");
            this.close();
            this.$message({ type: "success", message: "操作成功" });
          } else {
            this.$message({ type: "warning", message: res.Msg });
          }
        })
        .catch((err) => {
          loading.close();
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.div {
  margin: 18px 0;
}
.flex {
  display: flex;
}
.flex-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
}
</style>
